// protocol/define.ts
import type { ActionReq, ActionType } from './registry';
import type { Guard } from './guard';
export type Bucket = 'action' | 'chat';
export interface ActionDef<T extends ActionType = ActionType> { readonly type: T; readonly parse: Guard<ActionReq<T>>; readonly bucket: Bucket }
export function defineAction<T extends ActionType>(type: T, parse: Guard<ActionReq<T>>, bucket: Bucket = 'action'): ActionDef<T> {
  return { type, parse, bucket };
}
export function isActionDef(v: unknown): v is ActionDef {
  return typeof v === 'object' && v !== null && 'type' in v && 'parse' in v && 'bucket' in v;
}
/** Empty response type (§4.3). */
export type Ok = Record<string, never>;
